var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextbox1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 24,
    viewBox: "0 0 67 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.4919C0.5 11.6635 1.17157 10.9919 2 10.9919H65C65.8284 10.9919 66.5 11.6635 66.5 12.4919V21.4919C66.5 22.3204 65.8284 22.9919 65 22.9919H2C1.17157 22.9919 0.5 22.3204 0.5 21.4919V12.4919Z",
    fill: "white",
    stroke: "#ACACAC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 30,
    height: 8,
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextbox1A);
export default __webpack_public_path__ + "static/media/Textbox1A.fc73592a5e656fb542c2b6c8c11638d1.svg";
export { ForwardRef as ReactComponent };